import defaultAttributes from '../defaultAttributes';

const StickyNote = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d:
          'M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z',
      },
    ],
    ['path', { d: 'M15 3v6h6' }],
  ],
];

export default StickyNote;
